
import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    imports: [],
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loader.component.css"]
})
export class LoaderComponent implements OnInit {
  @Input() showCancel = false;
  @Output() cancelLoader: EventEmitter<string> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
  exitLoader() {
    this.cancelLoader.emit("exit");
  }
}
